import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgShareiOs({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 4h4a1 1 0 01.117 1.993L10 6H6a1 1 0 00-.993.883L5 7v11a1 1 0 00.883.993L6 19h12a1 1 0 00.993-.883L19 18v-6a1 1 0 011.993-.117L21 12v6a3 3 0 01-2.824 2.995L18 21H6a3 3 0 01-2.995-2.824L3 18V7a3 3 0 012.824-2.995L6 4h4-4zm12.707-1.707l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L18.586 7H18a8 8 0 00-8 8v1.018a1 1 0 11-2 0V15C8 9.477 12.477 5 18 5h.586l-1.293-1.293a1 1 0 011.414-1.414z"
        fill={color}
      />
    </svg>
  )
}

export default SvgShareiOs
